/**
 * Tiny helpers for SSO config values.
 *
 * Kept in a separate file so they can be imported without pulling in
 * any Angular runtime or config-service dependencies.
 */

/**
 * Extract the tenant ID from an MSAL authority URL.
 *
 *   https://login.microsoftonline.com/<tenantId>          → <tenantId>
 *   https://login.microsoftonline.com/<tenantId>/v2.0     → <tenantId>
 *   https://login.microsoftonline.com/common              → common
 *
 * Returns an empty string if the URL is malformed.
 */
export function extractTenantId(authority: string): string {
  try {
    const url = new URL(authority);
    const parts = url.pathname.split('/').filter(Boolean);
    return parts[0] ?? '';
  } catch {
    return '';
  }
}
